export default "__VITE_ASSET__GLD3MAdp__";